import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('base-modal-layout-footnote', {
  root: {
    variants: {
      skin: ['neutral', 'light'],
    },
  },
  divider: {},
  innerContent: {},
});
